module.exports = __webpack_public_path__ + "img/stop_btn.89372c27.png";